import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Typography } from '@mui/material';

const s:any = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  banner: {
    p: 2,
    borderRadius: 2,
    border: '1px solid #e4eefc',
    backgroundColor: '#f5f9ff',
  },
  checklist: {
    m: 0,
    pl: 3,
    lineHeight: 1.9,
  },
};

class StartPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  componentDidMount() {
    if (typeof this.props.setValid === 'function') this.props.setValid(true);
  }

  render() {
    return (
      <Box sx={{ ...s.root }}>
        <Box sx={{ ...s.banner }}>
          <Typography variant="h6">New Member Registration Wizard</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Follow the steps to capture personal, contact, family, and parish details before submission.
          </Typography>
        </Box>
        <Divider />
        <Box>
          <Typography variant="subtitle2">What you will complete</Typography>
          <Box component="ul" sx={{ ...s.checklist }}>
            <li>Personal identity and origin details</li>
            <li>Contact, guardian, and parent information</li>
            <li>Marriage and spouse information</li>
            <li>Parish history, group, and membership metadata</li>
            <li>Review and submit all data in one request</li>
          </Box>
        </Box>
      </Box>
    );
  }
}

StartPanel.propTypes = {
  classes: PropTypes.object,
};

export default StartPanel;

